var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-offset-container"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"nav-offset",attrs:{"id":_vm.idNextSection}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }